import { render, staticRenderFns } from "./shareKnow.vue?vue&type=template&id=7a2d13d6&scoped=true&"
import script from "./shareKnow.vue?vue&type=script&lang=js&"
export * from "./shareKnow.vue?vue&type=script&lang=js&"
import style0 from "./shareKnow.vue?vue&type=style&index=0&id=7a2d13d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d13d6",
  null
  
)

export default component.exports